import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { store, persistor } from './store';
import { initializeAuthListeners } from '@/store/slices/authSlice';
import { I18nProvider } from '@/components/common/I18nProvider';
import { initAnalytics } from '@/services/analytics';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import './i18n'; // Initialize i18n

// Initialize the new AuthService
console.log('DIAGNOSTIC: Main - AuthService initialized');

// Initialize auth listeners
initializeAuthListeners(store.dispatch);

// Load Umami analytics (production only by default; see analytics.ts)
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Expose store globally for testing purposes (only in development)
if (import.meta.env.DEV) {
  (window as any).__REDUX_STORE__ = store;
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nProvider>
          <App />
        </I18nProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
